/* Console signature for anyone who opens DevTools, plus a self-XSS warning.

   The warning is the part that earns its bytes: "paste this in your console"
   is a standard account-takeover script, and a loud message at the top of the
   console is the cheapest defence there is.

   Colors are duplicated from assets/ed-tokens.css because console format
   strings resolve against no document and cannot read custom properties:
     --ed-blue  #00a8ff   --ed-ink  #15171d   --ed-alert  #f54e38
   If the brand blue moves in ed-tokens.css, move it here too. */
(function () {
  /* Never in the theme editor — Shopify reloads sections constantly there and
     this would bury the editor's own console output. */
  if (window.Shopify && window.Shopify.designMode) return;
  if (!window.console || typeof console.log !== 'function') return;

  var MARK = [
    '',
    ' ███████╗██████╗ ██╗ ██████╗    ██████╗ ███████╗███████╗██╗  ██╗',
    ' ██╔════╝██╔══██╗██║██╔════╝    ██╔══██╗██╔════╝██╔════╝██║ ██╔╝',
    ' █████╗  ██████╔╝██║██║         ██║  ██║█████╗  ███████╗█████╔╝',
    ' ██╔══╝  ██╔═══╝ ██║██║         ██║  ██║██╔══╝  ╚════██║██╔═██╗',
    ' ███████╗██║     ██║╚██████╗    ██████╔╝███████╗███████║██║  ██╗',
    ' ╚══════╝╚═╝     ╚═╝ ╚═════╝    ╚═════╝ ╚══════╝╚══════╝╚═╝  ╚═╝',
    '',
  ].join('\n');

  var MONO = 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace';

  /* A broken easter egg must never be the reason a page misbehaves. */
  try {
    console.log('%c' + MARK, 'color:#00a8ff;font-family:' + MONO + ';font-size:10px;line-height:1.15');

    console.log(
      '%c Human made. No AI art, ever. ',
      'background:#00a8ff;color:#15171d;font-weight:700;padding:4px 10px;border-radius:4px'
    );

    console.log(
      '%cArtists — your work belongs on a desk:%c /pages/creator-club',
      'color:inherit;font-weight:600',
      'color:#00a8ff'
    );

    console.log('%cStop!', 'color:#f54e38;font-size:32px;font-weight:800;letter-spacing:0.02em');
    console.log(
      '%cThis console is a tool for developers.\n' +
        'If someone told you to paste something here to unlock a discount, fix an order,\n' +
        'or claim a giveaway, they are trying to take over your account. Close this window.',
      'font-size:13px;line-height:1.6'
    );

    /* Door two of three into the unlisted timeline. Anyone curious enough to
       open DevTools on a desk mat shop has earned it. The other two are the
       year cards on /pages/about-us and the 404. */
    console.log(
      '%cSince you are already in here — five years of us, dated:%c /pages/timeline',
      'color:inherit;font-weight:600',
      'color:#00a8ff'
    );

    console.log('%cBuilt in house. Epic Desk, 2026.', 'color:#8a8f9c;font-size:11px');
  } catch (e) {
    /* Older or restricted consoles: silently skip the whole thing. */
  }
})();
